import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  SavedReportViewDrawerComponent
} from "./saved-reports/saved-report-view-drawer/saved-report-view-drawer.component";
import {FolderFormComponent} from "./saved-reports/folder-form/folder-form.component";
import {FolderActionsMenuComponent} from "./saved-reports/folder-actions-menu/folder-actions-menu.component";
import {SavedReportsComponent} from "./saved-reports/saved-reports.component";
import {AddFolderCardComponent} from "./saved-reports/add-folder-card/add-folder-card.component";
import {AddReportCardComponent} from "./saved-reports/add-report-card/add-report-card.component";
import {ParentFolderCardComponent} from "./saved-reports/parent-folder-card/parent-folder-card.component";
import {FolderCardComponent} from "./saved-reports/folder-card/folder-card.component";
import {ReportTableRowComponent} from "./saved-reports/report-table/report-table-row/report-table-row.component";
import {SharedModule} from "../shared/shared.module";
import { ReportTableRowParametersComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters.component';
import { ReportTableRowParametersDimensionsComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-dimensions/report-table-row-parameters-dimensions.component';
import { ReportTableRowParametersMetricsComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-metrics/report-table-row-parameters-metrics.component';
import { ReportTableRowParametersPeriodComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-period/report-table-row-parameters-period.component';
import { ReportTableHeaderComponent } from './saved-reports/report-table/report-table-header/report-table-header.component';
import { ReportTableHeaderColumnComponent } from './saved-reports/report-table/report-table-header/report-table-header-column/report-table-header-column.component';
import { ReportTableComponent } from './saved-reports/report-table/report-table.component';
import { TableSortPipe } from './saved-reports/report-table/table-sort.pipe';
import { EditFolderButtonComponent } from './saved-reports/edit-folder-button/edit-folder-button.component';
import { SearchBarComponent } from './saved-reports/search-bar/search-bar.component';
import { SearchResultsComponent } from './saved-reports/search-results/search-results.component';
import { SearchContainerComponent } from './saved-reports/search-container/search-container.component';
import { SearchFilterComponent } from './saved-reports/search-filter/search-filter.component';
import { SearchResultsPipe } from './saved-reports/search-results/search-results.pipe';
import { SearchResultsItemComponent } from './saved-reports/search-results/search-results-item/search-results-item.component';
import { ReportTableRowParametersMetricComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-metric/report-table-row-parameters-metric.component';
import { ReportTableRowParametersFiltersComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-filters/report-table-row-parameters-filters.component';
import { SectionDropdownComponent } from './saved-reports/section-dropdown/section-dropdown.component';
import { ReportTableRowParametersChannelComponent } from './saved-reports/report-table/report-table-row/report-card-parameters/report-table-row-parameters-channel/report-table-row-parameters-channel.component';
import { ReportTableRowAddReportComponent } from './saved-reports/report-table/report-table-row-add-report/report-table-row-add-report.component';

@NgModule({
  declarations: [
    SavedReportsComponent,
    SavedReportViewDrawerComponent,
    FolderFormComponent,
    FolderActionsMenuComponent,
    AddFolderCardComponent,
    AddReportCardComponent,
    ParentFolderCardComponent,
    FolderCardComponent,
    ReportTableRowComponent,
    ReportTableRowParametersComponent,
    ReportTableRowParametersDimensionsComponent,
    ReportTableRowParametersMetricsComponent,
    ReportTableRowParametersPeriodComponent,
    ReportTableHeaderComponent,
    ReportTableHeaderColumnComponent,
    ReportTableComponent,
    TableSortPipe,
    EditFolderButtonComponent,
    SearchBarComponent,
    SearchResultsComponent,
    SearchContainerComponent,
    SearchFilterComponent,
    SearchResultsPipe,
    SearchResultsItemComponent,
    ReportTableRowParametersMetricComponent,
    ReportTableRowParametersFiltersComponent,
    SectionDropdownComponent,
    ReportTableRowParametersChannelComponent,
    ReportTableRowAddReportComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ]
})
export class SavedReportsModule { }
